import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { MlmPhotosType } from '~/tenants/mlm/performable/photos/MlmPhotosConfig';
import { MlmOrderContext, MlmOrderType } from '../../model/MlmOrder';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import MlmPhotosAddOns from './MlmPhotosAddOns';
import MlmPhotosExtra from './MlmPhotosExtra';
import { PersonaType } from '~/tenants/common/TenantPersona';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import ZodFieldInput from '~/components/zod/ZodFieldInput';

export default function MlmPhotosForm({ context, persona }: TenantPerformableFormProps<MlmOrderContext>) {
  const type = useZodFormFieldSingleValue('type');

  return (
    <FormGroup>
      {persona === PersonaType.OFFICE ? (
        <ZodFieldSelect
          name="type"
          options={[
            { label: 'Standard', value: MlmPhotosType.STANDARD },
            { label: 'Twilight Only', value: MlmPhotosType.TWILIGHT },
            { label: 'Event', value: MlmPhotosType.EVENT },
            { label: 'Reshoot', value: MlmPhotosType.RESHOOT },
            { label: 'Exterior Only', value: MlmPhotosType.EXTERIOR },
            { label: 'Partial', value: MlmPhotosType.PARTIAL },
          ]}
        />
      ) : (
        <ZodFieldHidden name="type" value={MlmPhotosType.STANDARD} />
      )}
      <FormHorizontal label="Special Instructions">
        <ZodFieldTextarea name="instructions" />
      </FormHorizontal>
      {context.metadata.type === MlmOrderType.COMMERCIAL && (
        <>
          <FormHorizontal label="Hours">
            <ZodFieldInput name="hours" />
          </FormHorizontal>
        </>
      )}
      {type === MlmPhotosType.STANDARD && (
        <>
          <FormHorizontal name="extra_photos" label="Extra Photos">
            <MlmPhotosExtra />
          </FormHorizontal>
          <TenantPerformableAddOns persona={persona}>
            <MlmPhotosAddOns persona={persona} />
          </TenantPerformableAddOns>
        </>
      )}
    </FormGroup>
  );
}
